import { getColors } from '../../utils'

const getStyles = (secondaryColor: string) => ({
    defaultMarker: {
        width: 40,
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: "translate(-50%, -50%)",
        bgcolor: secondaryColor,
        borderRadius: 6,
    },

    container: {
        display: "flex",
        width: "60px",
        flexDirection: "column",
        alignItems: "center",
        transform: "translate(-50%, -150px)",
        zIndex: 9999,
        position: "fixed",
        top: 40,
        left: 0,
        right: 0
    },


    bigCircle: {
        display: "flex",
        height: "60px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        borderRadius: "999px",
        background: secondaryColor,
    },

    duration: {
        color: "white"
    },

    min: {
        color: "white",
        fontWeight: 700,
        lineHeight: 1,
    },

    linkContainer: {
        position: "relative",
        height: "28px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "999px",
    },

    line: {
        position: "absolute",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "4px",
        height: "18px",
        background: secondaryColor,
        zIndex: 1,
    },

    smallCircle: {
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "18px",
        height: "18px",
        borderRadius: "999px",
        border: `4px solid ${secondaryColor}`,
        background: "#FFF",
    },

    paperStyle: {
        transform: "translate(-50%, -230px)",
        display: "flex",
        alignItems: "center",
        padding: '0px 12px 0px 0px',
        borderRadius: "12px",
        border: getColors().border,
        width: 'max-content',
        zIndex: 9999,
        pointerEvents: "none",
        position: "fixed",
        top: 40,
        left: 0,
        right: 0
    },

    controls: {
        position: "absolute",
        bottom: 8,
        right: 8,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        bgcolor: "background.paper",
        p: 0.5,
        borderRadius: "2px",
        boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px"
    },
    driverStyle: {
        display: "flex",
        zIndex: 9999,
        position: "relative",
        transform: "translate(-50%, -100%)",
    },
    spinner: {
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "white",
        zIndex: 2,
        background: getColors().bgwhite,

    }
});

export default getStyles;